import { IIconBase } from '..'

const reativarIcon = ({
  color = '#000000',
  height = 16,
  width = 16,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 459 416'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M224.935 1.0341C183.789 6.6761 148.243 22.2781 116.887 48.4581C72.9433 85.1491 45.7853 139.891 43.2403 196.908L42.6253 210.688L33.9493 202.198C24.8683 193.311 22.0653 191.629 16.3383 191.629C4.94725 191.629 -3.35675 203.89 1.33625 213.78C2.23325 215.669 13.8723 228.073 27.2013 241.345C61.0793 275.079 56.7913 275.079 90.6693 241.345C103.998 228.073 115.637 215.669 116.534 213.78C121.227 203.89 112.923 191.629 101.532 191.629C95.7923 191.629 92.9993 193.314 83.7663 202.35L74.9353 210.991L74.9363 207.06C74.9373 199.516 77.0283 181.061 78.8943 172.129C102.094 61.0271 223.099 0.381096 325.435 48.5661C375.8 72.2801 411.441 117.419 422.997 172.129C435.436 231.021 415.391 294.285 371.167 335.707C303.733 398.869 199.379 399.128 131.324 336.302C122.87 328.497 121.282 327.629 115.451 327.629C104.862 327.629 97.3933 336.594 99.3383 346.966C100.169 351.393 105.04 356.914 116.71 366.654C145.68 390.835 177.827 405.853 215.49 412.799C225.579 414.66 231.086 415.007 250.935 415.034C276.907 415.068 288.874 413.512 309.435 407.427C377.866 387.175 431.174 333.677 450.88 265.479C456.864 244.768 458.305 233.602 458.343 207.629C458.381 181.721 457.006 171.095 450.853 149.724C428.751 72.9601 365.313 16.5331 284.935 2.1411C272.307 -0.1199 237.969 -0.753902 224.935 1.0341Z'
        fill={color}
      />
    </svg>
  )
}

export default reativarIcon
